import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-bases',
  templateUrl: './bases.component.html',
  styleUrls: ['./bases.component.scss'],
})
export class BasesComponent implements OnInit {

  public bases = [
    {
      location: 'Base Buenos Aires',
      address: 'Somellera 4957',
      state: 'Ciudad Autónoma de Buenos Aires',
      code: 'C1439AAC',
      phones: [
        {
          number: '0810-44-429628 (HAZMAT)',
        },
        {
          number: '(011) 4899 – 2291',
        },
        {
          number: '(011) 15-4993-8570',
        },
        {
          number: '(011) 15-4993-5661',
        },
      ],
      email: 'info@hazmatargentina.com',
      img: 'assets/bases/base-ba.jpg',
    },
    {
      location: 'Base Santa Fe',
      address: 'Rosario',
      state: 'Prov. Santa Fe',
      code: '2000',
      phones: [
        {
          number: '0810-44-429628 (HAZMAT)',
        },
        {
          number: '(0341) 153345474',
        },
      ],
      email: 'matias@hazmatargentina.com',
      img: 'assets/bases/base-sf.jpeg',
    },
    {
      location: 'Base Santa Cruz',
      address: 'Santa Cruz',
      state: 'Provincia de Santa Cruz',
      code: '',
      phones: [
        {
          number: '0810-44-429628 (HAZMAT)',
        },
        {
          number: '(011) 4899 – 2291',
        },
        {
          number: '(011) 15-4993-8570',
        },
        {
          number: '(011) 15-4993-5661',
        },
      ],
      email: 'info@hazmatargentina.com',
      img: 'assets/bases/base-sc.jpeg',
    },
  ];
  constructor() {}

  ngOnInit() {}
}
